<script setup lang="ts" name="NavBarOrganisationSelectOption">
import type { IOrganisationType } from '~/types';

import AdminOrganisationsTypeTag from './AdminOrganisationsTypeTag.vue';

defineProps<{
  text: string;
  isActive?: boolean;
  isG2OEmployee?: boolean;
  type?: IOrganisationType;
}>();

const emit = defineEmits<{
  select: [];
}>();
</script>

<template>
  <button
    type="button"
    class="flex w-full max-w-full gap-x-2 overflow-hidden px-3 py-4"
    :class="{
      'text-black hover:bg-charcoal-1 hover:text-primary-8': !isActive,
      'bg-primary-8/10 text-primary-8 hover:bg-primary-8/20': isActive,
    }"
    @click.stop="emit('select')"
  >
    <p class="max-w-full truncate">
      {{ text }}
    </p>
    <div v-if="isG2OEmployee && type" class="w-0">
      <AdminOrganisationsTypeTag :value="type" class="min-w-max" />
    </div>
  </button>
</template>
